import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';

import { MethodService } from '@/infra/services/method';

interface UpdateMethodParams {
	organization_id?: string;
	company_id?: string;
	id: string;
	name: string;
	description: string;
}

const Service = MethodService.getInstance();

export const useUpdateMethod = () => {
	return useMutation({
		mutationFn: async (params: UpdateMethodParams) => Service.update(params),
		onError: () => {
			message.error(I18n.get('Error updating method'));
		}
	});
};
